module.exports = __webpack_public_path__ + "static/img/downloadandroid.f2685df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build902/components/footer/img/downloadandroid.svg
// module id = iGLd
// module chunks = 42